module.exports = __webpack_public_path__ + "img/[发呆].bdc920f0.svg";